import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { _AuxiliaryBrand } from "../../../../../../../core/services/dataBean/EntityCatalogVdos";
import useModal, { MODAL_LG, MODAL_SM } from "../../../../../../theme/Component/hooks/useModal";
import { toast } from "react-toastify";
import { _AccountantID, _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import { ListMenu } from "../../../../../../theme/Component/ListMenu";
import { BasicTable } from "../../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../../theme/Component/Modal";
import { SelectAccountantTree } from "../../../../../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree";
import { ModalConfirm } from "../../../../../../theme/Component/ModalConfirm";
import { PrintJson } from "../../../../../../theme/Component/PrintJson";


interface Props {
    idLine: number;
}

export const AuxiliaryBrandList = ({ idLine }: Props) => {

    const { instance, lista, setLista, bean, setBean } = useDataBean(_AuxiliaryBrand);
    const { instance: instanceAccountant } = useDataBean(_AccountantID);

    const modal = useModal("", MODAL_LG);

    useEffect(() => {
        getLista();
    }, [idLine])

    const getLista = () => {
        instance.getAuxiliaryBrandListForFixedAssetLine(idLine).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        ).catch(err => { toast.error(err) })

    }

    const editaItem = (obj: any) => {
        instanceAccountant.updateAccountantID(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDStr', visible: true },
        { title: 'Cuenta Depreciación Activo Almacenado', property: 'DepreciationStoredAccountantIDStr', visible: true },
        { title: 'Cuenta Depreciación Activo en Servicio', property: 'DepreciationInServiceAccountantIDStr', visible: true },
        { title: 'Cuenta Depreciación Activo Devolutivo', property: 'DepreciationReturnableAccountantIDStr', visible: true },
        { title: 'Cuenta Depreciación Activo en Mantenimiento', property: 'DepreciationMaintenanceAccountantIDStr', visible: true },
        { title: 'Cuenta Gasto Activo Almacenado', property: 'DepreciationExpensiveStoredAccountantIDStr', visible: true },
        { title: 'Cuenta Gasto Activo en Servicio', property: 'DepreciationExpensiveInServiceAccountantIDStr', visible: true },
        { title: 'Cuenta Gasto Activo Devolutivo', property: 'DepreciationExpensiveReturnableAccountantIDStr', visible: true },
        { title: 'Cuenta Gasto Activo Mantenimiento', property: 'DepreciationExpensiveMaintenanceAccountantIDStr', visible: true },

    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open(`Editar cuentas Contables auxiliares`); } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()}></BasicTable>

                <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { editaItem(bean) }}>
                    <div className="row">
                        <div className="col-md-6">
                            <SelectAccountantTree label="Cuenta Depreciación Activo Almacenado" jsonCode={bean.DepreciationStoredAccountantIDStr} onChange={(e) => { setBean({ ...bean, DepreciationStoredAccountantIDStr: e.JsonCode }) }} />
                        </div>
                        <div className="col-md-6">
                            <SelectAccountantTree label="Cuenta Depreciación Activo en Servicio" jsonCode={bean.DepreciationInServiceAccountantIDStr} onChange={(e) => { setBean({ ...bean, DepreciationInServiceAccountantIDStr: e.JsonCode }) }} />
                        </div>
                        <div className="col-md-6">
                            <SelectAccountantTree label="Cuenta Depreciación Activo Devolutivo" jsonCode={bean.DepreciationReturnableAccountantIDStr} onChange={(e) => { setBean({ ...bean, DepreciationReturnableAccountantIDStr: e.JsonCode }) }} />
                        </div>
                        <div className="col-md-6">
                            <SelectAccountantTree label="Cuenta Depreciación Activo en Mantenimiento" jsonCode={bean.DepreciationMaintenanceAccountantIDStr} onChange={(e) => { setBean({ ...bean,DepreciationMaintenanceAccountantIDStr: e.JsonCode }) }} />
                        </div>
                        <div className="col-md-6">
                            <SelectAccountantTree label="Cuenta Gasto Activo Almacenado" jsonCode={bean.DepreciationExpensiveStoredAccountantIDStr} onChange={(e) => { setBean({ ...bean, DepreciationExpensiveStoredAccountantIDStr: e.JsonCode }) }} />
                        </div>
                        <div className="col-md-6">
                            <SelectAccountantTree label="Cuenta Gasto Activo en Servicio" jsonCode={bean.DepreciationExpensiveInServiceAccountantIDStr} onChange={(e) => { setBean({ ...bean, DepreciationExpensiveInServiceAccountantIDStr: e.JsonCode }) }} />
                        </div>
                        <div className="col-md-6">
                            <SelectAccountantTree label="Cuenta Gasto Activo Devolutivo" jsonCode={bean.DepreciationExpensiveReturnableAccountantIDStr} onChange={(e) => { setBean({ ...bean, DepreciationExpensiveReturnableAccountantIDStr: e.JsonCode }) }} />
                        </div>
                        <div className="col-md-6">
                            <SelectAccountantTree label="Cuenta Gasto Activo Mantenimiento" jsonCode={bean.DepreciationExpensiveMaintenanceAccountantIDStr} onChange={(e) => { setBean({ ...bean, DepreciationExpensiveMaintenanceAccountantIDStr: e.JsonCode }) }} />
                        </div>
                    </div>
                </Modal>
            </div>

        </div>
    )
}